import { render, staticRenderFns } from "./DsbOrderListItem.vue?vue&type=template&id=457dcd8b"
import script from "./DsbOrderListItem.vue?vue&type=script&lang=ts"
export * from "./DsbOrderListItem.vue?vue&type=script&lang=ts"
import style0 from "./DsbOrderListItem.vue?vue&type=style&index=0&id=457dcd8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports